document.addEventListener('click', function (event) {
  const link = event.target.closest('.pelie-size-guide__nav a[href^="#"]');

  if (!link) return;

  const guide = link.closest('.pelie-size-guide');
  const target = guide?.querySelector(link.getAttribute('href'));

  if (!guide || !target) return;

  event.preventDefault();

  let scroller = target.parentElement;

  while (scroller && scroller !== document.body) {
    const style = window.getComputedStyle(scroller);
    const canScroll =
      /(auto|scroll|overlay)/.test(style.overflowY) &&
      scroller.scrollHeight > scroller.clientHeight;

    if (canScroll) break;
    scroller = scroller.parentElement;
  }

  if (!scroller || scroller === document.body) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    return;
  }

  const targetPosition =
    target.getBoundingClientRect().top -
    scroller.getBoundingClientRect().top +
    scroller.scrollTop -
    20;

  scroller.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
});